import { Loader, One } from './PreLoaderStyles';

const PreLoader = () => {
  return (
    <Loader>
      <One />
    </Loader>
  );
};

export default PreLoader;
